import { User } from 'configcat-react';
import { useMemo } from 'react';

import { useConfigStore } from '@/store.js';

export const useConfigCatUser = (): User | undefined => {
    const customerId = useConfigStore((state: any) => state.currentCustomer?.customer_id?.[0]?.text);

    return useMemo(() => (customerId ? new User(customerId) : undefined), [customerId]);
};
